module.exports = __webpack_public_path__ + "static/media/4a Underhook.b0160ea2.jpg";